import React from "react";
import Header from "../component/Header";
import ExploreResultLocations from "../component/ExploreResultLocations";
import Footer from "../component/Footer";
import ConnectAgentCTA from "../component/ConnectAgentCTA";
import BlogsDetailsImage from "../assets/images/blog-detail-img.png";
import BlogsDetailsImage1 from "../assets/images/blog-detail-img-1.png";
import { Col, Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import UserIcon from '../assets/images/user-1.svg';
import CalendarIcon from '../assets/images/calendar.svg';
import Facebook from '../assets/images/facebook-2.svg'
import X from '../assets/images/x-2.svg'
import Instagram from '../assets/images/instagram-2.svg'
import YouTube from '../assets/images/youtube-2.svg'
import LinkedIn from '../assets/images/linkedin.svg'

function NewsEventsDetails() {
 const relatedBlogs = [
    {
      id: '01',
      title: "Buyers: Results from the Real Estate Consumer Housing Trends Report 2025"
    },
    {
      id: '02',
      title: "Sellers: Results from the Real Estate Consumer Housing Trends Report 2025"
    },
    {
      id: '03',
      title: "Fed Cuts Rates, but Powell Says December Cut Is No Guarantee"
    },
    {
      id: '04',
      title: "Renters: Results from the Real Estate Consumer Housing Trends Report 2025"
    },
    {
      id: '05',
      title: "Buyers: Results from the Real Estate Consumer Housing Trends Report 2025"
    }
  ];
  return (
    <>
      <div className="main blog-details-page">
        <Header />
        <section className="blog-details-section common-padding">
          <Container>
            <Row>
              <Col lg={8} md={12}>
                <article className="blog-article">
                  <div className="article-header">
                    <span className="category-badge">Market Trends, News, Renting</span>
                    <h1 className="article-title">Real Estate: CPI Shelter Forecast, October 2025</h1>
                    <p className="article-subtitle">Real Estate forecasts that rent growth measured by the Consumer Price Index will soften further into 2026.</p>
                  </div>
                  <div className="featured-image">
                    <img 
                      src={BlogsDetailsImage}
                      alt="Modern Kitchen and Dining Area" 
                    />
                  </div>
                  <div className="article-meta">
                    <div className="author-info">
                        <img src={UserIcon} alt="John Doe" />
                      <span className="author-name">John Doe</span>
                    </div>
                    <div className="author-info">
                        <img src={CalendarIcon} alt="27 Apr 2025" />
                      <span className="author-name">27 Apr 2025</span>
                    </div>
                    
                    <div className="social-share">
                      <ul>
                        <li>
                          <a href="#" target="_blank">
                            <img src={Facebook} alt="Facebook" />
                          </a>
                        </li> 
                        <li>
                          <a href="#" target="_blank">
                            <img src={X} alt="X" />
                            </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src={Instagram} alt="Instagram" />
                          </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src={YouTube} alt="YouTube" />
                          </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src={LinkedIn} alt="LinkedIn" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Article Content */}
                  <div className="article-content">
                    <p>
                     New shelter inflation numbers from the Bureau of Labor Statistics are scheduled to be released on Thursday, November 13, 2025 at 8:30 ET.
                    </p>

                    <h2>Key Takeaway</h2>
                    <p>CPI housing inflation measures should continue to moderate into 2026, driven by decelerating market rents over the last few months. Near-term challenges in collecting and publishing official data may muddle the key trend of gradually slowing housing inflation.</p>

                    <h2>The Forecast</h2>
                    <h2>Owners’ Equivalent Rent (OER)</h2>
                    <p>Owner’s Equivalent Rent, which measures what homeowners would theoretically pay to rent their own homes, is projected to have increased 0.22% in October 2025 (95% confidence interval: 0.09% – 0.34%), higher than the 0.13% pace reported in September, but just slightly slower than the 0.26% average rate of the last quarter. We expect this measure to continue trending downward over the next year.</p>

                    <h2>Annual outlook</h2>
                    <p>We now forecast OER to end the year up 3.6% year-over-year, followed by a 2.8% increase in 2026. In September, the OER index was up 3.8% year-over-year.</p>

                    <h2>Rent of Primary Residence</h2>
                    <p>Rent of Primary Residence, which tracks rent payments, is projected to have increased 0.19% in October (95% confidence interval: 0.0.05% – 0.32%), roughly flat with the 0.20% reported in September.</p>

                    <h2>Annual outlook</h2>
                    <p>We forecast the Rent of Primary Residence index to end the year up 3.0% year-over-year, before decelerating to a 1.8% increase in 2026. In September, the Rent of Primary Residence index was up 3.4% year-over-year.</p>

                    <div className="content-image">
                      <img 
                        src={BlogsDetailsImage1}
                        alt="Modern House Exterior"
                      />
                    </div>

                    <h2>Market Rents</h2>
                    <p>Real Estate’s expectations for on-market rent growth in 2025 remained relatively unchanged: single-family rent expected to decelerate to 2.9% annually, while annual apartment rent increases should slow to 1.3%. Both measures are forecast to slow further in 2026, falling to 2.0% and -0.4% rent growth, respectively.</p>

                    <p>The shelter components of the CPI continue to increase at a faster pace than these on-market rent trends, reflecting not only new lease pricing but also rent changes for renewing and longer-term tenants.</p>

                    <h2>Methodology</h2>
                    <p>These forecasts are based on predictions from a model that makes explicit the relationship between on market rents (measured by the Real Estate’s Observed Rent Index) and the shelter components of the Consumer Price Index (CPI). </p>

                    <p>The model incorporates:</p>
                    <ul>
                      <li>Expected on-market rent growth (Real Estate’s Observed Rent Forecast, ZORF).</li>
                      <li>Assumptions about how landlords adjust rents at lease renewal.</li>
                      <li>Renter mobility rates, which determine what share of tenants face a market rent increase.</li>
                    </ul>
                  </div>
                </article>
              </Col>

              {/* Sidebar */}
              <Col lg={4} md={12}>
                <aside className="blog-sidebar">
                  <h3>Related Blogs</h3>
                  <div className="sidebar-widget">
                    <ul className="related-blogs-list">
                      {relatedBlogs.map((blog) => (
                        <li key={blog.id} className="related-blog-item">
                          <Link to={`/blog/${blog.id}`} className="blog-link">
                            <span>{blog.id}</span>
                            {blog.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </aside>
              </Col>
            </Row>
          </Container>
        </section>
        <ConnectAgentCTA />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}

export default NewsEventsDetails;
